








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { range, fromPairs } from 'lodash'

import Editor from '@/components/artifacts/NewEditor.tsx'
import NewEditor from '@/components/artifacts/NewEditor.tsx'
import { CaseWithMessages } from '@/queries/cases.graphql'
import Collapsible from '@/components/layout/Collapse.vue'
import YesOrNo from './report/YesOrNo.vue'
import SelectInput from './report/SelectInput.vue'
import TextInput from './report/TextInput.vue'
import IsFulfilled from './report/IsFulfilled.vue'
import { kebabToCamelCase } from '@/utils'
import { AxiosInstance } from 'axios'
import { CaseNodeFragment } from '@/graphql-schema'

export default Vue.extend({
  components: {
    Editor: NewEditor,
    Collapsible,
    IsFulfilled,
    SelectInput,
    TextInput,
    YesOrNo,
  },
  apollo: {
    pickedCase: {
      query() {
        return CaseWithMessages
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.value.case_id,
        }
      },
    },
  },
  computed: {
    traumaList(): string[] {
      return range(1, 26)
        .filter(i => this.relatedTraumaliste && i != 25 && this.relatedTraumaliste[`item_${i}`])
        .map(i => this.traumaliste[`item${i}`]!.prompt!.byLanguage![this.computedLocale])
    },
    relatedLec5(): any {
      const lec5: any = this.$store.getters['lec5/findBy']({
        case_id: this.value.case_id,
        time_of_measurement: 'pre',
      })
      if (!lec5) {
        return
      } else {
        return {
          ...lec5,
          worst_event_label: this.traumaliste[`item${lec5.worst_event}`]!.prompt!.byLanguage![
            this.computedLocale
          ],
        }
      }
    },
    relatedDemographics(): any {
      return this.$store.getters['demographics/findBy']({ case_id: this.value.case_id })
    },
    relatedTraumaliste(): any {
      return this.$store.getters['traumaliste/findBy']({ case_id: this.value.case_id })
    },
    /*pickedCase(): CaseNodeFragment {
      return this.$store.getters['availableCases'][this.value.case_id]
    },*/
    relatedPatient(): CaseNodeFragment['patient'] {
      return this.pickedCase?.patient
    },
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  mounted() {
    this.$emit('update:open', this.visible)
    this.$store.dispatch({ type: 'demographics/fetch' })
    this.$store.dispatch({ type: 'lec5/fetch' })
    this.$store.dispatch({ type: 'traumaliste/fetch' })
  },
  data() {
    return {
      copy: null,
      traumaliste: kebabToCamelCase(require('@/survey/measures/traumaliste/traumaliste.yml')),
      countryNames: require('@/locales/countries.yml'),
      patientStaticDataMockup: {
        age: 24,
        name_full: 'Vornamne Nachname',
        gender: 'male',
        country_of_residence: 'germany',
        access_fon: '0170123456',
        access_mail: 'mail@server.org',
        trauma_list: ['trauma a', 'trauma b'],
      },
      visible: { ...this.open },
      show: {
        arabic: false,
        english: true,
        german: false,
      },
    }
  },
  props: {
    value: {
      type: Object,
    },
    locale: {
      type: String,
    },
    open: {
      default: () => ({
        patientDetails: false,
        suicidality: false,
        hra: false,
        audit: false,
        dast: false,
        trauma: false,
        ptsd: false,
        cmde: false,
        pmde: false,
        cman: false,
        chman: false,
        pman: false,
        phman: false,
        dysthimia: false,
        psych: false,
        conclusion: false,
      }),
      type: Object,
    },
  },
  watch: {
    visible(nowIs: any) {
      this.$emit('update:open', nowIs)
    },
    open(nowIs: any) {
      this.visible = nowIs
    },
    'copy.patient_alias'(newValue: string, oldValue: string) {
      if (newValue != oldValue && this.relatedPatient && this.relatedPatient.userId) {
        const http: AxiosInstance = this.$store.getters.http
        console.log('new patient alias', newValue)
        http.patch(`/api/users?id=eq.${this.relatedPatient.userId}`, { alias: newValue })
      }
    },
  },
})
